import { timeParse } from 'd3-time-format';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const getParams = (window, width, height, margin = {}) => {
  const pageYOffset = window.pageYOffset;
  const xMax = width - margin.left - margin.right;
  const yMax = height - margin.top - margin.bottom;

  return {
    pageYOffset: pageYOffset,
    xMax: xMax,
    yMax: yMax,
  };
};

const getMonths = (startMonth = 7) => {
  let result = [];
  let j = startMonth - 1;
  for (let i = 0; i < 12; i++) {
    if (j > 11) j = 0;
    result.push(j);
    j++;
  }
  return result;
};

const getFinancialIndex = (m, startMonth = 7) => {
  let sm = startMonth;
  let index = 0;
  while (index < 12) {
    if (sm === m) break;
    sm++;
    if (sm > 12) sm = 1;
    index++;
  }

  return index;
};
const getMonths2 = (selectedMonth, startMonth = 7) => {
  let result = [];
  let j = startMonth - 1;
  for (let i = 0; i < 12; i++) {
    if (j > 11) j = 0;
    result.push(j);
    if (financialMonth(selectedMonth, startMonth) - 1 === j) break;
    j++;
  }
  return result;
};

const parseDate = timeParse('%Y-%m-%d');
const getMonth = (date) => {
  if (parseDate(date) !== null) {
    return parseDate(date).getMonth();
  }
  return new Date(date).getMonth();
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const convertMonth = (month) => {
  for (const [index, value] of months.entries()) {
    if (value === month) return index;
  }
};

const isEqualObjList = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  if (arr1.length === 0) return true;
  return (
    JSON.stringify(arr1[arr1.length - 1]) ===
    JSON.stringify(arr2[arr2.length - 1])
  );
};

const isEqualList = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  if (arr1.length === 0) return true;
  return arr1[arr1.length - 1] === arr2[arr2.length - 1];
};

const isMulti = (arrs) => {
  let isMulti = false;
  arrs.forEach((arr) => {
    isMulti = isMulti || arr.length > 0;
  });
  return isMulti;
};

const getIndexFromElementList = (els, el) => {
  for (let i = 0; i < els.length; i++) {
    if (els[i] === el) return i;
  }
  return -1;
};

const getIndexFromObjList = (objs, obj) => {
  for (let i = 0; i < objs.length; i++) {
    if (JSON.stringify(objs[i]) === JSON.stringify(obj)) return i;
  }
  return -1;
};

const randomColor = () =>
  ('#' + ((Math.random() * 0xffffff) << 0).toString(16) + '000000').slice(0, 7);

const deActivateEls = (els, className) => {
  els.forEach((el) => {
    el.classList.remove(className);
  });
};

const thousandFormat = (value) => {
  let x = parseFloat(value);
  if (!value || isNaN(x)) return '0';
  const converted = Math.round(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return converted;
};

const thousandFormat2 = (value, ch = '$') => {
  let x = Math.abs(parseFloat(value));
  if (!value || isNaN(x)) return ch + '0';
  const converted = Math.round(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (value < 0 ? '-' : '') + ch + converted;
};

const financialMonth = (month, startMonth = 7) => {
  month = parseInt(month);
  return ((10 + startMonth + month) % 12) + 1;
};

const financialMonthFrom = (month, startMonth = 7) => {
  month = parseInt(month);
  return ((12 - startMonth + month) % 12) + 1;
};

const getMonthForPoeplePage = (month) => {
  month = Math.abs(month);
  while (month > 12) {
    month = month % 100;
  }
  return Math.abs(month);
};

const financialYear = (year, month, startMonth) => {
  let y = parseInt(year);
  let m = parseInt(month);
  let s = parseInt(startMonth);
  return m >= s ? y - 1 : y;
};

const printFormat = {
  // For padding numbers with zeros (e.g., %04d)
  padNumber: (num, width) => {
      return String(num).padStart(width, '0');
  },

  // For date formatting (e.g., %04d%02d01)
  dateYYYYMMDD: (year, month) => {
      return `${String(year).padStart(4, '0')}${String(month).padStart(2, '0')}01`;
  },

  // For date with hyphens (e.g., %d-%02d-01)
  dateWithHyphens: (year, month) => {
      return `${year}-${String(month).padStart(2, '0')}-01`;
  },

  // For percentages with symbol (e.g., %2d%%)
  percentage: (value, decimals = 0) => {
      return `${Number(value).toFixed(decimals)}%`;
  },

  // For percentages without symbol (e.g., %d%)
  percentageValue: (value, decimals = 0) => {
      return Number(value).toFixed(decimals);
  },

  // For millions with decimal places (e.g., $%0.2fM)
  millions: (value) => {
      return `$${Number(value).toFixed(2)}M`;
  }
};

const makeDimDate = (full_year, full_month, startMonth) => {
  let y = parseInt(full_year);
  let m = parseInt(full_month);
  let s = parseInt(startMonth);
  return printFormat.dateYYYYMMDD(m < s ? y - 1 : y, financialMonth(m, s));
};

const arr_diff = (a1, a2) => {
  let a = [],
    diff = [];

  for (let i = 0; i < a1.length; i++) {
    a[a1[i]] = true;
  }

  for (let i = 0; i < a2.length; i++) {
    if (a[a2[i]]) {
      delete a[a2[i]];
    } else {
      a[a2[i]] = true;
    }
  }

  for (let k in a) {
    diff.push(parseInt(k));
  }

  return diff;
};

const CurrencyFormat = (
  amount,
  decimalCount = 2,
  decimal = '.',
  thousands = ',',
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      '$ ' +
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  } catch (error) {
    console.log(error.message);
  }
};

async function strategyExportToPdf(fileName) {
  let tableElement = document.getElementsByClassName('strategy_table')[0];

  html2canvas(tableElement, {
    scale: 2, // Higher scale for better quality
    useCORS: true, // For cross-origin images
    scrollX: 0,
    scrollY: 0,
    windowWidth: document.documentElement.offsetWidth,
    windowHeight: document.documentElement.offsetHeight,
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/jpg');
    const pdf = new jsPDF('l', 'mm', 'a4');
    const imgWidth = 297; // A4 width in mm for landscape
    const pageHeight = 210; // A4 height in mm for landscape
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Calculate the number of pages needed
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName);
  });
}

export {
  months,
  getParams,
  getMonth,
  isEqualObjList,
  isEqualList,
  isMulti,
  getIndexFromElementList,
  getIndexFromObjList,
  randomColor,
  deActivateEls,
  thousandFormat,
  financialMonth,
  financialMonthFrom,
  convertMonth,
  thousandFormat2,
  getMonths,
  getMonths2,
  makeDimDate,
  financialYear,
  getFinancialIndex,
  getMonthForPoeplePage,
  arr_diff,
  CurrencyFormat,
  strategyExportToPdf,
  printFormat
};
